import fetch from '@/api/clientFetchAdapter'
import { defineAsyncComponent, type App } from 'vue'

const devUrl = "/api"

// 定义全局对象类型
interface GlobalObject {
  $sleep: (ms: number) => Promise<void>
  $fetch: typeof fetch
  $extensionComponent: (extension: string, name: string) => any
  $shortString: (str: string | undefined, len?: number) => string | undefined
}

export const global: Partial<GlobalObject> = {}

// API URL 生成函数
const apiUrl = (path: string): string => {
  return devUrl + path
}

// 扩展组件缓存
const extensionComponents: Record<string, any> = {}

// 加载扩展组件
const loadExtensionComponent = (extension: string, name: string): Promise<any> => {
  return new Promise((resolve) => {
    import(
      /* @vite-ignore */
      '/extension/' + extension + '/assets/remoteEntry.js'
    ).then((res: any) => {
      res.get(name).then((res: any) => {
        let com = res()
        com.created = function () {
          const originalFetch = this.$fetch
          this.$fetch = {
            get: (url: string, data?: any, config?: any) => {
              url = '/extension/' + extension + url
              return originalFetch.get(url, data, config, extension)
            },
            post: (url: string, data?: any, config?: any) => {
              url = '/extension/' + extension + url
              return originalFetch.post(url, data, config, extension)
            },
            put: (url: string, data?: any, config?: any) => {
              url = '/extension/' + extension + url
              return originalFetch.put(url, data, config, extension)
            },
            delete: (url: string, data?: any, config?: any) => {
              url = '/extension/' + extension + url
              return originalFetch.delete(url, data, config, extension)
            },
          }
        }
        resolve(com)
      })
    })
  })
}

// 全局工具函数
global.$sleep = (ms: number): Promise<void> => {
  let sleepSetTimeout_ctrl: NodeJS.Timeout
  clearInterval(sleepSetTimeout_ctrl)
  return new Promise(resolve => sleepSetTimeout_ctrl = setTimeout(resolve, ms))
}

global.$fetch = fetch

global.$extensionComponent = (extension: string, name: string) => {
  return defineAsyncComponent(() => loadExtensionComponent(extension, name))
}

global.$shortString = function (str: string | undefined, len?: number): string | undefined {
  if (str == undefined) {
    return undefined
  }
  if (len == undefined) {
    len = 10
  }
  if (str.length > len) {
    return str.substring(0, len) + '...'
  }
  return str
}

// Loading 函数增强
interface LoadingOptions {
  throttle?: number
  [key: string]: any
}

interface LoadingInstance {
  close: () => void
}

const myloading = (oldLoadingFunc: (options?: LoadingOptions) => LoadingInstance) => {
  const newLoadingFunc = (options?: LoadingOptions): LoadingInstance => {
    let loader: LoadingInstance | null = null

    const timer = setTimeout(() => {
      loader = oldLoadingFunc(options)
    }, options?.throttle || 300)

    const close = () => {
      clearTimeout(timer)
      if (loader) {
        loader.close()
      }
    }
    return { close }
  }
  return newLoadingFunc
}

// 替换全局函数
const replaceFuncs = (app: App) => {
  app.config.globalProperties['$loading'] = myloading(app.config.globalProperties['$loading'])
}

// 插件安装函数
const install = function (app: App) {
  replaceFuncs(app)

  for (const [key, attr] of Object.entries(global)) {
    app.config.globalProperties[key] = attr
  }
}

export default { install, apiUrl }
